import { Injectable } from '@angular/core';
import { TimeUtils } from '@freelancer/time-utils';
import { Tracking } from '@freelancer/tracking';
import { ApplicationType } from '../types';

interface TrackingData {
  action?: string;
  label?: string;
  name?: string;
  value?: string;
  reference?: string;
  referenceId?: number;
}

@Injectable()
export class FinopsTrackingService {
  private section: ApplicationType;

  constructor(private tracking: Tracking, private timeUtils: TimeUtils) {}

  initiate(section: ApplicationType) {
    this.section = section;

    const heartBeatTracking = (currentInterval: number) => {
      this.pushTrackingData({
        label: 'pageHeartBeat',
      });
      const nextInterval = this.getTrackingInterval(currentInterval);
      this.timeUtils.setTimeout(
        heartBeatTracking.bind(
          undefined, // no context passed
          nextInterval,
        ),
        currentInterval,
      );
    };
    heartBeatTracking(10000);
  }

  pushTrackingData(trackingData: TrackingData) {
    this.handleTrackingEvent(trackingData);
  }

  popUpHeartbeat(popUpName: string, componentName: string, popUp: Window) {
    const heartBeatTracking = (interval: number) => {
      if (popUp.closed) {
        return;
      }
      this.pushTrackingData({
        label: `${popUpName}Heartbeat`,
        name: componentName,
      });
      const newInterval = this.getTrackingInterval(interval);
      this.timeUtils.setTimeout(
        heartBeatTracking.bind(
          undefined, // no context passed
          newInterval,
        ),
        interval,
      );
    };
    heartBeatTracking(1000);
  }

  private handleTrackingEvent(trackingData: TrackingData) {
    this.tracking.track('user_action', {
      section: this.section,
      action: trackingData.action,
      label: trackingData.label,
      extra_params: {
        name: trackingData.name,
        value: trackingData.value,
        reference: trackingData.reference,
        reference_id: trackingData.referenceId,
      },
    });
  }

  private getTrackingInterval(currentValue: number): number {
    return Math.round(currentValue * 1.15);
  }
}
